import LoaderDivs from "@/components/loaders/loader-divs";

const PlaceListSkeleton = () => {
  return (
    <div className="w-full flex flex-col gap-2 px-2 divide-y divide-gray-200 dark:divide-brown">
      {new Array(5).fill(0).map((_, i) => (
        <div key={i} className="w-full flex items-center h-40 gap-4">
          <div className="w-full flex flex-col gap-2">
            <LoaderDivs className={"w-28 h-5 md:h-7 rounded-xl"} />
            <LoaderDivs className={"w-full h-5 rounded-xl"} />
            <LoaderDivs className={"w-[80%] h-3.5 rounded-xl"} />
            <LoaderDivs className={"w-20 h-3 rounded-xl"} />
          </div>
          <LoaderDivs className={"w-24 min-w-24 h-32 rounded-xl"} />
        </div>
      ))}
    </div>
  );
};

export default PlaceListSkeleton;
